// Load jQuery
import $ from 'jquery';
const { CountUp } = require('countup.js');
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

// load fonts
WebFont.load({
    google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
        families: ['Noto+Sans:400,500,600,700&display=swap']
    },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('select2/dist/js/select2.full.min');

//Load Modules
require('./modules/accordion');
require('./modules/bannerVideo');
require('./modules/formInputs');
require('./modules/gravityForms'); // only include if using WordPress Gravity plugin
require('./modules/videoButtonReplacer');
require('./modules/videoPlay');
require('./modules/menu');
require('./modules/scrollTo');
require('./modules/tabs');
require('./modules/stepsSlider');
require('./modules/teamMemberSlider');
require('./modules/newsSlider');
require('./modules/fullwidthctahover');
require('./modules/slider');
require('./modules/ajaxPagination');

var options = {
	useEasing: true,
	useGrouping: true,
	separator: ",",
	decimal: ".",
    duration: 3,
};

var statistics = $(".statistic-number");

statistics.each(function(index) {
    var value = $(statistics[index]).html();
	var statisticAnimation = new CountUp(statistics[index], value, options);
    $(document).ready(function (event) {
        if ($(window).scrollTop() > ($(statistics[index]).offset().top - $(window).height())) {
            statisticAnimation.start();
            $(statistics[index]).off(event);
        }
    }); 
    $('body').scroll(function(event) {
        if ($(window).scrollTop() > ($(statistics[index]).offset().top - $(window).height())) {
            statisticAnimation.start();
            $(statistics[index]).off(event);
        }
    }); 
	
}); 